<template>
  <div class="seafCon">
    <div class="header">
      <!-- 安全组 -->
      <header-tag :title="'规则分组管理'"></header-tag>
      <div style="display:inline-block;" class="btnGroupCon">
        <Button type="info" @click="isShowZu = true">安全组分类管理</Button>
      </div>
      <!-- <div style="display:inline-block;" class="btnGroupCon">
        <Button type="info" @click="editorFn(0)">新建安全组</Button>
        <Button type="info" :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == ''"
          @click="editorFn(1)">修改</Button>
        <Button type="info" :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == ''"
          @click="shareBar(0)">分配网吧</Button>
        <Button type="info" @click="shareBar(1)"
          :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == ''">分配规则</Button>
        <Button type="warning" @click="delFn()"
          :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == '' || selectData.secGroupId == 1">删除</Button>
      </div> -->
    </div>
    <!-- 表格部分 -->
    <div class="tal" style="margin: 10px 0 10px 30px;">
      <!-- <span style="margin-left: 10px;">选择分类:</span> -->
      <!-- <Select  style="width: 200px;" v-model="groupTypeId" placeholder="请选择安全组类别">
        <Option value=''>全部</Option>
        <Option v-for="(item,index) in data2" :value="item.id" :key="index">{{ item.securityTypeName }}</Option>
      </Select> -->
      <!-- <Button-group>
        <Button :type="groupTypeId == ''?'primary':''" v-if="data2.length>1" @click="groupTypeId =''">全部</Button>
        <Button v-for="(item,index) in data2" v-if="data2.length>1" :key="index" :type="item.id == groupTypeId ?'primary':''"  @click="groupTypeId = item.id">{{ item.securityTypeName }}
          (<b v-text="item.secGroupNum == null?0 :item.secGroupNum"></b>)</Button>
    </Button-group> -->
    </div>
    <div  class="btnGroupCon2 tal">
      <div :class="[isShowPf?'btnPf':'']">
        <Button type="info" @click="editorFn(0)">新建安全组</Button>
        <Button type="info" :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == ''"
          @click="editorFn(1)">修改</Button>
        <Button type="info" :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == ''"
          @click="shareBar(0)">分配网吧</Button>
        <Button type="info" @click="shareBar(1)"
          :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == ''">分配规则</Button>
        <Button type="warning" @click="delFn()"
          :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == '' || selectData.secGroupId == 1">删除</Button>
          <Button type="info" @click="isShowRemove=true"
          :disabled="selectData.secGroupId == undefined || this.selectData.secGroupId == '' || selectData.secGroupId == 1">移动分类</Button>
      </div>
    </div>
    <div class="table-content">
      <Collapse :accordion="true" v-model="isType" class="tal" v-if="data2.length>1">
        <Panel  :name="item.id.toString()" v-for="(item,index) in data2" :key="index">
          {{ item.securityTypeName }}(<b v-text="item.secGroupNum == null ? 0 :item.secGroupNum"></b>)
          <p slot="content" style="min-height:300px;" >
            <Table  border :loading="isLoading" stripe :row-class-name="rowClassName" :columns="columns" :data="data" @on-row-click="clickFn">
              <template slot="bars" slot-scope="{row,index}">
                <div class="tagCon" v-for="(item, index) in  row.bars" :key="index">{{ item.barName }} <b
                    v-if="index != row.bars.length - 1">,
                  </b>
                </div>
              </template>
              <template slot="rules" slot-scope="{row,index}">
                <p class="ells1" v-for="(item, index) in  row.rules" :key="index">
                  <Tooltip :content="item.ruleName">
                    {{ item.ruleName }}
                  </Tooltip>
                </p>
              </template>
            </Table>
          </p>
        </Panel>
      </Collapse>
      <Table border stripe :row-class-name="rowClassName" :columns="columns" :data="data" @on-row-click="clickFn" v-else>
        <template slot="bars" slot-scope="{row,index}">
          <div class="tagCon" v-for="(item, index) in  row.bars" :key="index">{{ item.barName }} <b
              v-if="index != row.bars.length - 1">,
            </b>
          </div>
        </template>
        <template slot="rules" slot-scope="{row,index}">
          <p class="ells1" v-for="(item, index) in  row.rules" :key="index">
            <Tooltip :content="item.ruleName">
              {{ item.ruleName }}
            </Tooltip>
          </p>
        </template>
      </Table>
    </div>
    <div class="mackCon pf pr" v-if="isEditor">
      <div class="inMaskCon pa">
        <div class="title tal pr f14"><span v-text="type == 1 ? '修改安全组' : '新增安全组'"></span><i class="closeIncon f30 pa"
            @click="isEditor = false">×</i></div>
        <div class="bodyCon">
          <Form :label-width="80">
            <Form-item label="安全组名称">
              <Input placeholder="请输入" v-model="selectData.securityName" style="width:400px;"></Input>
            </Form-item>
            <Form-item label="选择分类">
              <Select  class="tal" v-model="secGroupTypeId" placeholder="请选择安全组类别">
                <Option v-for="(item,index) in data2" :value="item.id" :key="index">{{ item.securityTypeName }}</Option>
              </Select>
            </Form-item>
            <Form-item label="备注信息">
              <textarea class="textErea" v-model="selectData.remark" cols="30" rows="5"></textarea>
            </Form-item>
          </Form>
        </div>
        <div class="footCon tar">
          <Button @click="isEditor = false">取消</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" type="primary" @click="saveFn">保存</Button>
        </div>
      </div>
    </div>
    <div class="mackCon pf pr" v-if="isBar">
      <div class="inMaskCon pa">
        <div class="title tal pr f14">
          <span v-text="type === 1 ? '分配规则' : '分配网吧'"></span><i class="closeIncon f30 pa" @click="isBar = false">×</i>
        </div>
        <div class="bodyCon" style="width:800px;">
          <h4 class="tal f14 titleCon">
            <span v-if="type === 1">选择要分配到【{{ selectData.securityName }}】的规则</span>
            <span v-else>选择要分配到【{{ selectData.securityName }}】的网吧</span>
          </h4>
          <Input style="margin:10px 0;" v-model="searchVal"
            :placeholder="type == 1 ? '请输入规则名称快速查找' : '请输入网吧名快速查找'"></Input>
          <div class="tal scrollStyle" style="max-height:300px;overflow-y: auto;">
            <template v-if="type == 0">
              <Checkbox-group @on-change="changeFn" v-model="selectVal" style="width:100%;">
                <Checkbox :label="item.barId" v-for="(item, index) in newBarList" :key="index"
                  style="width:200px;margin-left:2px;" class="ells1"><span style="padding-left:4px;">{{ item.barName
                  }}</span>
                </Checkbox>
              </Checkbox-group>
              <p v-if="newBarList == ''">暂无符合筛选条件的数据！</p>
            </template>
            <template v-if="type == 1">
              <Checkbox-group v-model="selectVal" @on-change="changeFn" style="width:100%;">
                <Checkbox :label="item.ruleId" v-for="(item, index) in newRuleList" :key="index"
                  style="width:350px;margin-left:2px;" class="ells1" :title="item.ruleName"><span>【{{item.ruleId}}】{{ item.ruleName
                  }}</span>
                </Checkbox>
              </Checkbox-group>
              <p v-if="newRuleList == ''">暂无符合筛选条件的数据！</p>
            </template>
            <!-- <Checkbox :indeterminate="indeterminate" style="margin:10px 0;" :value="checkAll" @change="handleCheckAll">
              全选
            </Checkbox> -->
          </div>
          <div class="tal" style="margin-top: 10px;padding-top: 10px; border-top: 1px solid #eee;">
            <template v-if="type == 0 && selectData.bars !=null">
              <Collapse >
                <Panel name="1">
                        已选择的网吧【<b class="mainCol f14">{{ selectData.bars.length }}</b>】
                    <p slot="content"> <Row  class="mainCol marginTop4" v-if="selectData.bars !=''">
                          <Col span="8" v-for="(item,index) in selectData.bars"   :key="index" >{{ item.barName }}</Col>
                      </Row>
                      <span class="errorCol" v-else>未分配网吧!</span>
                    </p>
                </Panel>
              </Collapse>
            </template>
            <template v-if="type == 1 && selectData.rules !=null">
              <Collapse >
                <Panel name="1">
                  已选择的规则【<b class="mainCol f14">{{ selectData.rules.length }}</b>】
                    <p slot="content">
                      <Row  class="mainCol marginTop4"  v-if="selectData.rules !=''">
                        <Col span="8" class="ells1" v-for="(item,index) in selectData.rules"   :key="index" >【{{item.ruleId}}】{{ item.ruleName }}</Col>
                      </Row>
                      <span class="errorCol" v-else>未分配网吧!</span>
                    </p>
                </Panel>
              </Collapse>
            </template>
          </div>
        </div>
        <div class="footCon tar">
          <Button @click="isBar = false">取消</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" type="primary"  @click="saveFn2">保存</Button>
        </div>
      </div>
    </div>
    <div class="mackCon pf pr" v-if="isShowZu">
      <div class="inMaskCon pa">
        <div class="title tal pr f14">
          <span v-text="'安全组分类管理'"></span><i class="closeIncon f30 pa" @click="isShowZu = false">×</i>
        </div>
        <div class="bodyCon" style="width:600px;">
          <p class="tar addBtn">
            <Button type="info" @click="isEditorLei = true" v-if="!isEditorLei" >新建安全组分类</Button>
            <Input v-model="securityTypeName" v-else placeholder="请输入分类名称">
              <span slot="append" class="cp" @click="addLei">&nbsp;&nbsp;添加&nbsp;&nbsp;</span>
            </Input>
          </p>
          <Table border   :columns="columnsZu" :data="data2">
            <template slot-scope="{row,index}" slot="action">
                <Button size="small" type="warning" v-if="row.id !=1"  @click="delZu(row)" class="marginLeft10">删除</Button>
              </template>
              <template slot-scope="{row,index}" slot="securityTypeName">
                <template v-if="row.id ==1">{{row.securityTypeName}}
                </template>
                <div class="clearfix" v-else>
                  <template v-if="!row.isEditor " >
                    <div style="width: calc(100% - 20px);" class="ells1 fl"  :title="row.securityTypeName">{{row.securityTypeName}}</div>
                    <i class="editorIcon fr cp" @click="editorLname(row)"></i>
                  </template>
                  <template v-else>
                    <Input v-model="row.securityTypeName" placeholder="请输入分类名称">
                      <span slot="append" class="cp" @click="addLeiRow(row)">&nbsp;&nbsp;修改&nbsp;&nbsp;</span>
                    </Input>
                  </template>
                </div>
              </template>
              <template slot-scope="{row,index}" slot="remark">
                <div class="clearfix">
                  <template v-if="!row.isEditorRemark" >
                    <div style="width: calc(100% - 20px);" class="ells1 fl" :title="row.remark">{{row.remark}}</div>
                    <i class="editorIcon fr cp" @click="editorLRemark(row)"></i>
                  </template>
                  <template v-else>
                    <Input v-model="row.remark" placeholder="请输入分类名称">
                      <span slot="append" class="cp" @click="addLeiRow(row)">&nbsp;&nbsp;添加&nbsp;&nbsp;</span>
                    </Input>
                  </template>
                </div>
              </template>
          </Table>
        </div>
        <div class="footCon tar">
          <Button @click="isShowZu = false" class="cp">取消</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" type="primary" @click="isShowZu = false">确定</Button>
        </div>
      </div>
    </div>
    <div class="mackCon pf pr" v-if="isShowRemove">
      <div class="inMaskCon pa">
        <div class="title tal pr f14">
          <span v-text="'移动分组'"></span><i class="closeIncon f30 pa" @click="isShowRemove = false">×</i>
        </div>
        <div class="bodyCon" style="width:600px;">
          <h4 class="tal f14 titleCon">
            安全组名称：{{selectData.securityName}}
          </h4>
          <h4 class="tal f14 titleCon" style="margin:10px 0;">
            已分配网吧数：{{selectData.barCount}}
            <Poptip style="margin-left: 10px;" v-if="selectData.barCount>0">
                <a>网吧列表</a>
                <div slot="content" v-for="(item,index) in selectData.bars" :key="index">
                  {{ item.barName }}({{ item.barId }}) <b v-if="index != selectData.bars.length -1">;</b>
                </div>
            </Poptip>
          </h4>
          <h4 class="tal f14 titleCon" style="margin:10px 0;" v-if="selectData.rules !=null">
            已分配规则数：{{selectData.rules.length}}
            <Poptip style="margin-left: 10px;" v-if=" selectData.rules.length>0">
                <a>规则列表</a>
                <div slot="content" v-for="(item,index) in selectData.rules" :key="index">
                  {{ item.ruleName }}({{ item.ruleId }}) <b v-if="index != selectData.rules.length -1">;</b>
                </div>
            </Poptip>
          </h4>
          <div class="tal f14">
            安全组类别：
            <Select  style="width: 200px;" v-model="groupTypeId2" placeholder="请选择安全组类别">
              <Option v-for="(item,index) in data2" :value="item.id" :key="index">{{ item.securityTypeName }}</Option>
            </Select>
          </div>
        </div>
        <div class="footCon tar">
          <Button @click="isShowRemove = false">取消</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" type="primary"  @click="saveFn3">保存</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag';
// 网吧列表
import TableList from './TableList';
import {
  getGroupList,
  editSecurityGroup,
  moveSecurityGroup,
  getRuleManageList,
  applyRule2SecurityGroup,
  delSecurityGroup,
} from '@/requests/securityCenter';
import {
  secGroupTypeAdd,
  secGroupTypeList,
  secGroupTypeEdit,
  secGroupTypeDel,
  transforGroupType,
} from '@/requests/secGroup';
import { getPageOfBar } from '@/requests/selfClient';
import { getBarListNew } from '@/requests/proTree';
export default {
  name: 'safetyRules',
  components: {
    HeaderTag,
    TableList,
  },
  data() {
    return {
      isShowPf: false,
      indeterminate: true,
      checkAll: false,
      isEditor: false,
      isBar: false,
      searchVal: '',
      total: 0,
      page: 1,
      size: 100,
      type: 0,
      columns: [
        // {
        //   type: 'selection',
        //   width: 60,
        //   align: 'center'
        // },
        {
          title: '安全组名称',
          key: 'securityName',
          width: 240,
          sortable: true,
          align: 'center',
        },
        {
          title: '安全组类别',
          key: 'securityTypeName',
          sortable: true,
          width: 160,
          align: 'center',
        },
        {
          title: '组内网吧数',
          key: 'barCount',
          width: 90,
          align: 'center',
          sortable: true,
        },
        {
          title: '已经分配网吧',
          key: 'bars',
          slot: 'bars',
        },
        {
          title: '已分配规则',
          key: 'rules',
          slot: 'rules',
          width: 300,
        },
        {
          title: '备注',
          key: 'remark',
          width: 200,
          align: 'right',
        },
      ],
      data: [],
      selectData: {},
      curIndex: '',
      btnLoading: false,
      selectVal: [],
      barList: [],
      newBarList: [],
      ruleList: [],
      newRuleList: [],
      isShowZu: false,
      columnsZu: [
        {
          title: '分类名称',
          key: 'securityTypeName',
          sortable: true,
          slot: 'securityTypeName',
          align: 'center',
        },
        {
          title: '分配的安全组数',
          key: 'secGroupNum',
          sortable: true,
          align: 'center',
        },
        // {
        //   title: '备注',
        //   key: 'remark',
        //   slot: 'remark',
        //   align: 'left',
        // },
        {
          title: '操作',
          key: 'action',
          slot: 'action',
          align: 'center',
          width: 70,
        },
      ],
      isEditorLei: false,
      data2: [],
      securityTypeName: '',
      groupTypeId: '',
      curData: '',
      groupTypeId2: '',
      isShowRemove: false,
      secGroupTypeId: 1,
      actionType: '',
      isType: '',
      isLoading: false,
    };
  },
  computed: {},
  watch: {
    isType() {
      this.groupTypeId = this.isType;
    },
    groupTypeId() {
      this.getGroupList();
    },
    async isShowZu() {
      if (this.isShowZu) {
        this.getGroupZu();
      }
    },
    ruleList() {
      this.newRuleList = this.ruleList;
      setTimeout(() => {
        this.selectValFn();
      }, 1);
    },
    barList() {
      this.newBarList = this.barList;
      setTimeout(() => {
        this.selectValFn();
      }, 1);
    },
    searchVal() {
      if (this.type == 0) {
        this.newBarList = [];
        this.barList.forEach((el) => {
          let index = el.barName.indexOf(this.searchVal);
          if (index != -1) {
            this.newBarList.push(el);
          }
        });
      } else {
        this.newRuleList = [];
        this.ruleList.forEach((el) => {
          let index = el.ruleName.indexOf(this.searchVal);
          if (index != -1) {
            this.newRuleList.push(el);
          }
        });
      }
      setTimeout(() => {
        this.selectValFn();
      }, 1);
    },
  },
  mounted() {
    this.getGroupZu();
    this.getGroupList();
    document.getElementById('home-content').addEventListener('scroll', () => {
      this.onScroll();
    });
  },
  methods: {
    typeChange(val) {
      console.log(val);
    },
    onScroll() {
      let scrolled = document.getElementById('home-content').scrollTop;
      console.log(scrolled);
      if (scrolled > 77) {
        this.isShowPf = true;
      } else {
        this.isShowPf = false;
      }
    },
    // async secGroupTypeList() {
    //   let res = await secGroupTypeList()
    //   if (res.code == 200) {
    //     this.secGroupTypeData = res.data
    //   }
    // },
    async saveFn3() {
      let res = await transforGroupType({
        groupIdList: [this.selectData.secGroupId],
        groupTypeId: this.groupTypeId2,
      });
      if (res.code == 200) {
        this.$Message.success('操作成功！');
        this.getGroupList();
        this.isShowRemove = false;
        this.getGroupZu();
      } else {
        this.$Message.error(res.msg);
      }
    },
    async getGroupZu() {
      let res = await secGroupTypeList();
      if (res.code == 200) {
        res.data.forEach((el) => {
          el.isEditor = false;
        });
        this.data2 = res.data;
      }
    },
    async delZu(val) {
      this.$Modal.confirm({
        title: '确定删除此条规则分类吗？',
        content: '删除后，已分配到该分组的安全组全部重新分配到默认分组中！',
        onOk: async () => {
          let res = await secGroupTypeDel({
            id: val.id,
          });
          if (res.code == 200) {
            this.getGroupZu();
          } else {
            this.$Message.error(res.msg);
          }
        },
      });
    },
    editorLRemark(val) {
      val.isEditorRemark = true;
    },
    async addLeiRow(val) {
      let res = await secGroupTypeEdit({
        securityTypeName: val.securityTypeName,
        id: val.id,
        remark: '',
      });
      if (res.code == 200) {
        val.isEditor = false;
        this.getGroupZu();
      } else {
        this.$Message.error(res.msg);
      }
    },
    editorLname(val) {
      val.isEditor = true;
    },
    async addLei() {
      let res = await secGroupTypeAdd({
        securityTypeName: this.securityTypeName,
        remark: '',
      });
      if (res.code == 200) {
        this.$Message.success('添加成功');
        this.isEditorLei = false;
        this.getGroupZu();
      } else {
        this.$Message.error(res.msg);
      }
    },
    changeFn(val) {
      if (this.type == 0) {
        if (this.newBarList.length == this.barList.length) {
          if (val != '') {
            this.selectData.bars = [];
            val.forEach((el) => {
              let index = this.barList.findIndex((val2) => val2.barId == el);
              if (index != -1) {
                let json = {
                  barId: this.barList[index].barId,
                  barName: this.barList[index].barName,
                };
                this.selectData.bars.push(json);
              }
            });
          } else {
            this.selectData.bars = [];
          }
        } else {
          if (val == '') {
            this.newBarList.forEach((el) => {
              let index = this.selectData.bars.findIndex((val2) => val2.barId == el.barId);
              if (index != -1) {
                this.selectData.bars.splice(index, 1);
              }
            });
          } else {
            this.newBarList.forEach((el) => {
              let index = this.selectData.bars.findIndex((val2) => val2.barId == el.barId);
              if (index != -1) {
                this.selectData.bars.splice(index, 1);
              }
            });
            val.forEach((el) => {
              let index = this.barList.findIndex((val2) => val2.barId == el);
              if (index != -1) {
                let json = {
                  barId: this.barList[index].barId,
                  barName: this.barList[index].barName,
                };
                let key = this.selectData.bars.findIndex(
                  (val2) => val2.barId == this.barList[index].barId
                );
                if (key == -1) {
                  this.selectData.bars.push(json);
                }
              }
            });
          }
        }
      } else {
        if (this.newRuleList.length == this.ruleList.length) {
          if (val != '') {
            this.selectData.rules = [];
            val.forEach((el) => {
              let index = this.ruleList.findIndex((val2) => val2.ruleId == el);
              if (index != -1) {
                let json = {
                  ruleId: this.ruleList[index].ruleId,
                  ruleName: this.ruleList[index].ruleName,
                };
                this.selectData.rules.push(json);
              }
            });
          } else {
            this.selectData.rules = [];
          }
        } else {
          if (val == '') {
            this.newRuleList.forEach((el) => {
              let index = this.selectData.rules.findIndex((val2) => val2.ruleId == el.ruleId);
              if (index != -1) {
                this.selectData.rules.splice(index, 1);
              }
            });
          } else {
            this.newRuleList.forEach((el) => {
              let index = this.selectData.rules.findIndex((val2) => val2.ruleId == el.ruleId);
              if (index != -1) {
                this.selectData.rules.splice(index, 1);
              }
            });
            val.forEach((el) => {
              let index = this.ruleList.findIndex((val2) => val2.ruleId == el);
              if (index != -1) {
                let json = {
                  ruleId: this.ruleList[index].ruleId,
                  ruleName: this.ruleList[index].ruleName,
                };
                let key = this.selectData.rules.findIndex(
                  (val2) => val2.ruleId == this.ruleList[index].ruleId
                );
                if (key == -1) {
                  this.selectData.rules.push(json);
                }
              }
            });
          }
        }
      }
    },
    selectValFn() {
      this.selectVal = [];
      if (this.type == 0) {
        if (this.selectData.bars != undefined) {
          this.selectData.bars.forEach((el) => {
            this.selectVal.push(el.barId);
          });
        }
      } else {
        if (this.selectData.rules != undefined) {
          console.log(this.selectData.rules);
          this.selectData.rules.forEach((el) => {
            this.selectVal.push(el.ruleId);
          });
        }
      }
    },
    // handleCheckAll () {
    //   if (this.indeterminate) {
    //     this.checkAll = false
    //   } else {
    //     this.checkAll = !this.checkAll
    //   }
    //   this.indeterminate = false
    //   if (this.checkAll) {
    //     this.selectVal = []
    //     if (this.type == 0) {
    //       this.newBarList.forEach(el => {
    //         this.selectVal.push(el.barId)
    //       })
    //     } else {
    //       this.newRuleList.forEach(el => {
    //         this.selectVal.push(el.ruleId)
    //       })
    //     }
    //   } else {
    //     this.selectVal = []
    //   }
    // },
    delFn() {
      window.$Message.show({
        title: '删除安全组',
        type: 'info',
        msg: `你确定要删除安全组【${this.selectData.securityName}】吗？`,
        cancleBtn: true,
        confirmFn: async () => {
          let res = await delSecurityGroup({
            id: this.selectData.secGroupId,
          });
          if (res.code == 200) {
            this.getGroupList();
            window.$Message.hide();
          } else {
            this.$Notice.error({ title: res.msg });
          }
        },
      });
    },
    async getRuleManageList() {
      this.selectVal = [];
      if (this.selectData.rules != undefined) {
        this.selectData.rules.forEach((el) => {
          this.selectVal.push(el.id);
        });
      }
      let res = await getRuleManageList({
        current: 1,
        size: 1000,
      });
      if (res.code == 200) {
        res.data.records.forEach((el) => {
          el.ruleId = el.id;
        });
        this.ruleList = res.data.records;
        if (res.data.total > 1000) {
          let res2 = await getRuleManageList({
            current: 2,
            size: 1000,
          });
          if (res2.code == 200) {
            res.data.records.forEach((el) => {
              el.ruleId = el.id;
              this.ruleList.push(el);
            });
          }
        }
      }
    },
    async saveFn2() {
      this.btnLoading = true;
      let res;
      if (this.type == 0) {
        res = await moveSecurityGroup({
          barId: this.selectVal.toString(),
          securityGroupId: this.selectData.secGroupId,
        });
      } else {
        res = await applyRule2SecurityGroup({
          ruleIds: this.selectVal.toString(),
          securityGroupId: this.selectData.secGroupId,
        });
      }

      this.btnLoading = false;
      if (res.code == 200) {
        this.isBar = false;
        this.getGroupList();
      } else {
        this.$Notice.error({ title: res.msg });
      }
    },
    async getPageOfBar() {
      this.selectVal = [];
      if (this.selectData.bars != undefined) {
        this.selectData.bars.forEach((el) => {
          this.selectVal.push(el.barId);
        });
      }

      let res = await getBarListNew();
      if (res.code == 200) {
        res.data.forEach((el) => {
          el.bars = el.bars == null ? [] : el.bars;
          el.rules = el.rules == null ? [] : el.rules;
        });
        this.barList = res.data;
      }
    },
    shareBar(type) {
      this.isBar = true;
      this.type = type;
      if (type == 0) {
        this.getPageOfBar();
      } else {
        this.getRuleManageList();
      }
    },
    async saveFn() {
      this.btnLoading = true;
      let res = await editSecurityGroup({
        id: this.selectData.secGroupId,
        securityName: this.selectData.securityName,
        remark: this.selectData.remark,
        secGroupTypeId: this.secGroupTypeId,
      });
      this.btnLoading = false;
      if (res.code == 200) {
        this.getGroupList();
        this.isEditor = false;
        this.secGroupTypeId = 1;
      } else {
        this.$Notice.error({ title: res.msg });
      }
    },
    editorFn(type) {
      if (!type) {
        this.selectData = {};
        this.selectData.secGroupId = '';
        this.selectData.securityName = '';
        this.selectData.remark = '';
        this.curIndex = '';
        this.secGroupTypeId = 1;
      }
      this.type = type;
      this.isEditor = true;
    },
    rowClassName(row, index) {
      if (index === this.curIndex) {
        return 'demo-table-info-row';
      }
    },
    clickFn(val, index) {
      console.log(val, index);
      this.secGroupTypeId = val.secGroupTypeId;
      this.groupTypeId2 = val.secGroupTypeId;
      if (this.curIndex === index) {
        this.curIndex = '';
        this.selectData = '';
      } else {
        val.bars == null ? [] : val.bars;
        val.rules == null ? [] : val.rules;
        this.selectData = val;
        this.curIndex = index;
      }
    },
    async getGroupList() {
      this.selectData = '';
      this.curIndex = '';
      this.isLoading = true;
      this.data = [];
      let res = await getGroupList({
        current: this.page,
        size: this.size,
        groupTypeId: this.groupTypeId,
      });
      if (res.code == 200) {
        this.isLoading = false;
        this.data = res.data.records;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding-left: 30px;
  text-align: left;
  position: relative;
  z-index: 10;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}

.right {
  float: right;
  padding-right: 20px;

  a {
    margin-left: 6px;
    line-height: normal;
  }
}

.table-content {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;

  .search {
    text-align: left;
    margin-bottom: 10px;

    input {
      width: 150px;
      height: 30px;
      border: 1px solid rgba(215, 215, 215, 1);
      padding-left: 3px;
      margin-right: 10px;
    }

    span {
      margin: 0 5px 0 10px;
    }

    select {
      width: 185px;
      height: 30px;
      border: 1px solid rgba(215, 215, 215, 1);
      outline: none;
    }
  }
}

.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;

  > div {
    display: inline-block;
  }
}

.btnGroupCon {
  padding-left: 10px;
  button {
    margin-left: 10px;
  }
}
.btnGroupCon2 {
  padding-left: 20px;
  margin-top: 10px;
  button {
    margin-left: 10px;
  }
}

.tagCon {
  padding: 2px;
  display: inline-block;
  margin-right: 10px;
}

.textErea {
  width: 400px;
  border: 1px solid #eee;
}
.marginTop4 {
  margin-top: 4px;
}
.addBtn {
  margin-bottom: 10px;
}
.editorIcon {
  width: 16px;
  height: 16px;
  background: url('../../../assets/img/icon/u2910.png') no-repeat center;
  background-size: 100%;
  vertical-align: text-bottom;
  margin-top: 2px;
}
</style>
<style lang="scss">
.seafCon {
  .ivu-table .demo-table-info-row td {
    background-color: #2db7f5 !important;
    color: #fff;
  }
  .ivu-collapse-content,
  .ivu-collapse-content > .ivu-collapse-content-box {
    padding: 0 !important;
  }
  .btnGroupCon button {
    height: 28px;
  }
  .header .ivu-btn {
    line-height: 28px !important;
  }
  .marginLeft10 {
    margin-left: 10px;
  }
  .ivu-affix {
    top: 60px !important;
    background: #fff;
  }
}
.btnPf {
  position: fixed;
  top: 60px;
  z-index: 9;
  background: #fff;
  width: 100%;
  left: 380px;
  padding: 10px 0 10px 20px;
  box-shadow: 0 0 10px 0px rgba($color: #000000, $alpha: 0.4);
}
</style>
